module.exports = __webpack_public_path__ + "static/media/image-3.8768af01.jpg";